export default __webpack_public_path__ + "static/media/mini-anima-logo-disabled.533a04fb.svg";